import OpenSans from "../../../assets/fonts/OpenSans-Regular.ttf";
import OpenSansSemiBold from "../../../assets/fonts/OpenSans-SemiBold.ttf";
import OpenSansBold from "../../../assets/fonts/OpenSans-Bold.ttf";
import { StyleSheet, Font } from "@react-pdf/renderer";
import { themes } from "../../../modules/theme";

Font.register({
  family: "OpenSans",
  format: "truetype",
  src: OpenSans,
});

Font.register({
  family: "OpenSansSemiBold",
  format: "truetype",
  src: OpenSansSemiBold,
});

Font.register({
  family: "OpenSansBold",
  format: "truetype",
  src: OpenSansBold,
});

const GeneralStyle = StyleSheet.create({
  inLineBlocks: {
    display: "flex",
    flexDirection: "row",
  },
  semiBold: {
    fontFamily: "OpenSansSemiBold",
  },
  bold: {
    fontFamily: "OpenSansBold",
  },
  regular: {
    fontFamily: "OpenSans",
  },
  page: {
    paddingBottom: "35",
    backgroundColor: themes.default.whiteSmoke,
    fontFamily: "OpenSans",
  },
  marginTopAuto: {
    marginTop: "auto",
  },
});

export default GeneralStyle;
